/**
 * "Daily speed test" (Connection Quality faza 4): explicatia si alegerea orei,
 * aceleasi pe cardul aparatului si pe panoul firmei.
 *
 * Ora e ora LOCALA a aparatului - agentul o citeste pe ceasul masinii, deci
 * doua aparate in fusuri orare diferite testeaza fiecare la "3 noaptea" al lui.
 */

/** Textul de rezerva, cand serverul nu trimite `speedHelp` (Speed::DAILY_HELP). */
export const SPEED_HELP =
  'Uses bandwidth: up to about 25 MB in each direction, for about 20 seconds. It starts with a random delay of up to 40 minutes after the chosen hour, only one test runs at a time on the same internet connection, and it never runs on metered connections or on low battery.'

export const HOURS = Array.from({ length: 24 }, (_, h) => h)

export function hourLabel(h: number): string {
  return `${String(h).padStart(2, '0')}:00`
}

export function SpeedHourSelect({
  id,
  value,
  disabled,
  onChange,
}: {
  id?: string
  value: number
  disabled: boolean
  onChange(hour: number): void
}) {
  return (
    <select
      id={id}
      name="speed_hour"
      className="form-control input-sm cq-speed-hour"
      aria-label="Speed test hour"
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(Number(e.target.value))}
    >
      {HOURS.map((h) => (
        <option key={h} value={h}>
          {hourLabel(h)}
        </option>
      ))}
    </select>
  )
}
